import React from "react";
import "./linkExpired.css";

function LinkExpired() {
  return (
    <div className="link-expired-page">
      <div className="link-expired-card">
        <div className="link-expired-icon" aria-hidden="true">
          <i className="bi bi-hourglass-bottom" />
        </div>

        <h1 className="link-expired-title">This link has expired</h1>
        <p className="link-expired-copy">
          The link you followed is no longer active. Links are time-limited for
          your security and may have already been used.
        </p>

        <div className="link-expired-divider" />

        <p className="link-expired-hint">
          Need a new link or help? Please contact your clinic directly.
        </p>
      </div>
    </div>
  );
}

export default LinkExpired;
